export default __webpack_public_path__ + "static/custom-marker-shapes-daab097e8ade8c5c4177244cfded97fc.png";